
import { WorldCountry } from '../types';

export const otherSouthAmericaCountries: WorldCountry[] = [
  {
    code: 'PY',
    name: 'Paraguay',
    slug: 'paraguay',
    population: 7132538,
    topCities: [
      { name: 'Asunción', slug: 'asuncion', population: 525000 },
      { name: 'Ciudad del Este', slug: 'ciudad-del-este', population: 293000 },
      { name: 'San Lorenzo', slug: 'san-lorenzo', population: 252000 },
      { name: 'Luque', slug: 'luque', population: 244000 },
      { name: 'Capiatá', slug: 'capiata', population: 232000 },
      { name: 'Lambaré', slug: 'lambare', population: 158000 },
      { name: 'Fernando de la Mora', slug: 'fernando-de-la-mora', population: 153000 },
      { name: 'Limpio', slug: 'limpio', population: 114000 },
      { name: 'Ñemby', slug: 'nemby', population: 108000 },
      { name: 'Encarnación', slug: 'encarnacion', population: 93000 }
    ]
  },
  {
    code: 'UY',
    name: 'Uruguay',
    slug: 'uruguay',
    population: 3473730,
    topCities: [
      { name: 'Montevideo', slug: 'montevideo', population: 1319000 },
      { name: 'Salto', slug: 'salto', population: 104000 },
      { name: 'Paysandú', slug: 'paysandu', population: 73000 },
      { name: 'Las Piedras', slug: 'las-piedras', population: 71000 },
      { name: 'Rivera', slug: 'rivera', population: 64000 },
      { name: 'Maldonado', slug: 'maldonado', population: 62000 },
      { name: 'Tacuarembó', slug: 'tacuarembo', population: 54000 },
      { name: 'Melo', slug: 'melo', population: 51000 },
      { name: 'Mercedes', slug: 'mercedes', population: 41000 },
      { name: 'Artigas', slug: 'artigas', population: 40000 }
    ]
  },
  {
    code: 'BO',
    name: 'Bolivia',
    slug: 'bolivia',
    population: 11673021,
    topCities: [
      { name: 'Santa Cruz de la Sierra', slug: 'santa-cruz-de-la-sierra', population: 1453549 },
      { name: 'El Alto', slug: 'el-alto', population: 848840 },
      { name: 'La Paz', slug: 'la-paz', population: 835361 },
      { name: 'Cochabamba', slug: 'cochabamba', population: 630587 },
      { name: 'Sucre', slug: 'sucre', population: 281451 },
      { name: 'Tarija', slug: 'tarija', population: 234442 },
      { name: 'Potosí', slug: 'potosi', population: 189652 },
      { name: 'Sacaba', slug: 'sacaba', population: 169494 },
      { name: 'Quillacollo', slug: 'quillacollo', population: 137029 },
      { name: 'Oruro', slug: 'oruro', population: 264683 }
    ]
  },
  {
    code: 'EC',
    name: 'Ecuador',
    slug: 'ecuador',
    population: 17643054,
    topCities: [
      { name: 'Guayaquil', slug: 'guayaquil', population: 2278691 },
      { name: 'Quito', slug: 'quito', population: 1680000 },
      { name: 'Cuenca', slug: 'cuenca-ec', population: 329928 },
      { name: 'Santo Domingo', slug: 'santo-domingo-ec', population: 270875 },
      { name: 'Machala', slug: 'machala', population: 245972 },
      { name: 'Durán', slug: 'duran', population: 230839 },
      { name: 'Manta', slug: 'manta', population: 226477 },
      { name: 'Portoviejo', slug: 'portoviejo', population: 223086 },
      { name: 'Ambato', slug: 'ambato', population: 165185 },
      { name: 'Riobamba', slug: 'riobamba', population: 146324 }
    ]
  },
  {
    code: 'VE',
    name: 'Venezuela',
    slug: 'venezuela',
    population: 28435940,
    topCities: [
      { name: 'Caracas', slug: 'caracas', population: 2245744 },
      { name: 'Maracaibo', slug: 'maracaibo', population: 1495200 },
      { name: 'Valencia', slug: 'valencia-ve', population: 830033 },
      { name: 'Barquisimeto', slug: 'barquisimeto', population: 809490 },
      { name: 'Ciudad Guayana', slug: 'ciudad-guayana', population: 746535 },
      { name: 'San Cristóbal', slug: 'san-cristobal-ve', population: 246583 },
      { name: 'Maracay', slug: 'maracay', population: 407109 },
      { name: 'Ciudad Bolívar', slug: 'ciudad-bolivar', population: 338000 },
      { name: 'Cumana', slug: 'cumana', population: 405626 },
      { name: 'Barinas', slug: 'barinas', population: 353442 }
    ]
  },
  {
    code: 'CL',
    name: 'Chile',
    slug: 'chile',
    population: 19116201,
    topCities: [
      { name: 'Santiago', slug: 'santiago-cl', population: 5614000 },
      { name: 'Valparaíso', slug: 'valparaiso', population: 296655 },
      { name: 'Concepción', slug: 'concepcion-cl', population: 223574 },
      { name: 'La Serena', slug: 'la-serena', population: 221054 },
      { name: 'Antofagasta', slug: 'antofagasta', population: 361873 },
      { name: 'Temuco', slug: 'temuco', population: 282415 },
      { name: 'Rancagua', slug: 'rancagua', population: 241774 },
      { name: 'Talca', slug: 'talca', population: 220357 },
      { name: 'Arica', slug: 'arica', population: 221364 },
      { name: 'Chillán', slug: 'chillan', population: 184739 }
    ]
  },
  {
    code: 'GY',
    name: 'Guyana',
    slug: 'guyana',
    population: 786552,
    topCities: [
      { name: 'Georgetown', slug: 'georgetown-gy', population: 118363 },
      { name: 'Linden', slug: 'linden', population: 44690 },
      { name: 'New Amsterdam', slug: 'new-amsterdam', population: 17329 },
      { name: 'Anna Regina', slug: 'anna-regina', population: 12448 },
      { name: 'Bartica', slug: 'bartica', population: 11157 },
      { name: 'Skeldon', slug: 'skeldon', population: 5859 },
      { name: 'Rosignol', slug: 'rosignol', population: 5782 },
      { name: 'Mahaica', slug: 'mahaica', population: 4867 },
      { name: 'Parika', slug: 'parika', population: 4385 },
      { name: 'Springlands', slug: 'springlands', population: 3821 }
    ]
  },
  {
    code: 'SR',
    name: 'Suriname',
    slug: 'suriname',
    population: 586632,
    topCities: [
      { name: 'Paramaribo', slug: 'paramaribo', population: 241000 },
      { name: 'Lelydorp', slug: 'lelydorp', population: 18663 },
      { name: 'Nieuw Nickerie', slug: 'nieuw-nickerie', population: 12818 },
      { name: 'Moengo', slug: 'moengo', population: 7074 },
      { name: 'Nieuw Amsterdam', slug: 'nieuw-amsterdam', population: 4935 },
      { name: 'Mariënburg', slug: 'marienburg', population: 4427 },
      { name: 'Wageningen', slug: 'wageningen-sr', population: 4145 },
      { name: 'Albina', slug: 'albina', population: 3985 },
      { name: 'Groningen', slug: 'groningen-sr', population: 3216 },
      { name: 'Brokopondo', slug: 'brokopondo', population: 3019 }
    ]
  },
  {
    code: 'GF',
    name: 'French Guiana',
    slug: 'french-guiana',
    population: 298682,
    topCities: [
      { name: 'Cayenne', slug: 'cayenne', population: 61550 },
      { name: 'Saint-Laurent-du-Maroni', slug: 'saint-laurent-du-maroni', population: 47621 },
      { name: 'Kourou', slug: 'kourou', population: 25682 },
      { name: 'Matoury', slug: 'matoury', population: 32427 },
      { name: 'Remire-Montjoly', slug: 'remire-montjoly', population: 26143 },
      { name: 'Macouria', slug: 'macouria', population: 12322 },
      { name: 'Mana', slug: 'mana', population: 9445 },
      { name: 'Apatou', slug: 'apatou', population: 8026 },
      { name: 'Grand-Santi', slug: 'grand-santi', population: 6001 },
      { name: 'Papaichton', slug: 'papaichton', population: 7292 }
    ]
  }
];
